import clsx from 'clsx';
import SorryIcon from 'images/img/modal/sorry.svg';
import { useTranslation } from 'react-i18next';
import { FEButton } from 'ui-kit/components';
import style from './Empty.module.css';

type Props = {
  onAdd: () => void;
};

export const Empty = ({ onAdd }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={style.container}>
      <img className={style.icon} src={SorryIcon} alt='' />
      <h1 className={clsx('title', style.title)}>
        {t('profile.addressesEmptyTitle')}
      </h1>
      <p className={clsx('text-2', style.message)}>
        {t('profile.addressesEmptyMessage')}
      </p>
      <FEButton className={style.button} onClick={onAdd} type='secondary'>
        {t('profile.addressesAdd')}
      </FEButton>
    </div>
  );
};
